export const pushEvent = (event: object) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}